<template>
  <div>
  <div id="homePage-3" v-if=" this.$i18n.locale == 'zh'">
    <div class="part-title">
      <h3>{{msg}}</h3>
      <p>星球数据为企业数字化保驾护航</p>
    </div>
<ul>
  <li>1、ERP系统（库存、采购、财务、会计、审批流程）。</li>
  <li>2、人工智能技术应用、移动互联应用技术。</li>
  <li>3、RFID系统（药监码、固定资产、智能仓储、防伪防窜）。</li>
  <li>4、智能产品开发与应用、工业机器人技术。</li>
  <li>5、大数据技术，在线考试系统，毕业设计，裁判文书等。</li>
</ul>
  </div>

  <div id="homePage-3" v-if=" this.$i18n.locale == 'en'">
    <div class="part-title">
      <h3>Freelancer</h3>
      <p>Custom Software Development</p>
    </div>
    <div class="carousel">
    <div @click="prevSlide" class="carousel-prev-icon-left"></div>
    <div class="carousel-slides">
      <img
        v-for="(image, index) in images"
        :key="index"
        :src="image"
        :style="{left: index * 100 + '%', 'transform': dynamicstyle}"
        alt="暂无图片"
      />
    </div>
    <div @click="nextSlide" class="carousel-prev-icon-right"></div>
  </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'PageThree',
  props: {
    speed: Number,
    direction: String
  },
  data () {
    return {
      msg: '定制开发',
      images: [
        require("../../../assets/img/freelancer/photo_2024-03-22_19-38-50.jpg"),
        require("../../../assets/img/freelancer/photo_2024-04-02_15-32-30.jpg"),
        require("../../../assets/img/freelancer/photo_2024-03-21_18-07-43.jpg"),
        require("../../../assets/img/freelancer/photo_2024-04-07_18-27-03.jpg"),
        require("../../../assets/img/freelancer/photo_2024-03-09_01-10-28.jpg"),
        require("../../../assets/img/freelancer/photo_2024-03-15_21-05-36.jpg"),
        require("../../../assets/img/freelancer/photo_2024-04-12_22-33-35.jpg"),
      ],
      dynamicstyle: "", //动态样式
      currentSlide: 0, //播放序号
      interval: Object,
    }
  },
  mounted() {
    this.startSlideshow()
  },
  methods: {
    nextSlide() {
      // 每次指针加一
      this.currentSlide = (this.currentSlide + 1) % this.images.length
      this.setStyle();
    },
    prevSlide() {
      // 每次减一，为负数时循环
      this.currentSlide = (this.currentSlide - 1 + this.images.length) % this.images.length;
      this.setStyle();
    },
    // 图片动画
    setStyle() {
      this.dynamicstyle = `translatex(-${this.currentSlide*100}%)`
    },
    // 定时器
    startSlideshow() {
      this.interval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.images.length;
        this.setStyle();
      }, 3000)
    },
    stopSlideshow() {
      clearInterval(this.interval)
    }
  }
}
</script>
<style lang="scss" scoped>
#homePage-3 {
  width: 100%;
  height: 100%;
  padding-top: 120px;
  background: url("~assets/img/banner/bg_diandian.png") center no-repeat,
              linear-gradient(to right,#fff 0,#f1f2f6 100%);
  background-size: cover;
}
.part-title {
  position: relative;
  width: 100%;
  margin-bottom: 65px;
  -webkit-transition: all 1s;
  transition: all 1s;
  text-align: center;
  h3 {
    margin-bottom: 10px;
    font-size: 30px;
    font-weight: 700;
    color: #072c69;
  }
  p {
    font-size: 16px;
    color: #acadb3;
  }
}
ul{
    font-size: 20px;
    margin: 2rem auto;
    text-align: left;
    display: inline-block;
    list-style-type: none;
    line-height: 40px;
  }
.carousel {
  position: relative;
}
.carousel-slides {
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  height: 600px;
  width: 800px;
}
.carousel-slides img {
  display: inline-block;
  position: absolute;
  width: inherit;
  align-self: center;
  top: 55px;
  height: 414px;
  width: 800px;
  border: none;
  transition: 0.8s transform ease-in-out;
}
.carousel-controls {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}
.carousel-prev-icon-left {
  position: absolute;
  left: 10px;
  top: 55px;
  height: 50px;
  width: 40px;
  border: none;
  //background-image: url(../../../assets/img/arrow-l.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
}
.carousel-prev-icon-right {
  position: absolute;
  right: 10px;
  top: 55px;
  height: 50px;
  width: 40px;
  border: none;
  //background-image: url('../../../assets/img/arrow-r.png/');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 999;
}
</style>
